import { AuthState } from "@okta/okta-auth-js";
import appHistory from "../AppHistory";

export const validateAuthState = (auth: AuthState) => {
  if (!auth || (!auth.isAuthenticated)) {
    appHistory.push("/login");
  }
}
